import { NAV_BRAND } from '@/config'
import { PORTAL_TYPE_YF } from '@/config/constants'

import defaultState from './defaultState'

export default ({ ratingWidget: { activateError, ...ratingWidget } = {} } = {}) => ({
  ...defaultState,
  enabled: NAV_BRAND.portal_type === PORTAL_TYPE_YF && !NAV_BRAND.portal_is_at,
  ...ratingWidget
})
